import React from "react";
import styled from "styled-components/macro";
import { Button, Stack } from "@mui/material";
import Snowfall from "react-snowfall";
import { Trans } from "react-i18next";
import Countdown from "components/other/Countdown";
import { useSaleExpiration } from "./subscriptionHooks";

const Title = styled.h1`
  font-size: 24px;
  margin: 0;
  padding: 0px;
  text-transform: uppercase;
`;
const Hero = styled.p`
  font-size: 36px;
  margin: 0;
  font-weight: bold;
`;
const DiagonalBG = styled.div`
  position: absolute;
  top: -3px;
  left: -3px;
  width: 110%;
  height: 220px;
  background-color: #ffa600;
  background: linear-gradient(
    to right,
    #ffd600,
    #ffa600
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
`;
const OfferTop = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  left: 0;
  top: 20px;
`;
const OfferBottom = styled.div`
  margin-top: 200px;
`;
const ExpirationTitle = styled.h2`
  font-size: 22px;
`;
const Expiration = styled.div`
  font-size: 26px;
`;
const OfferWrap = styled.div`
  background-color: #fff;
  margin: -45px -15px -17px;
  padding: 40px 30px;
  width: 290px;
  overflow: hidden;
  position: relative;
`;
const SImg = styled.img`
  max-width: 75px;
`;
const SButtonWrap = styled.div`
  margin-top: 40px;
`;

type Props = {
  onClose: () => void;
};

const SaleDialogDefault: React.FC<Props> = ({ onClose }) => {
  const { saleExpiration, saleDiscount, saleTitle } = useSaleExpiration();

  return (
    <OfferWrap>
      <DiagonalBG>
        <Snowfall color={"#CE8E00"} snowflakeCount={20} />
      </DiagonalBG>
      <OfferTop>
        <Stack direction="column" justifyContent="space-around" alignItems="center" style={{ height: "135px" }}>
          <SImg src={"https://cdn.duocards.com/img/crown.png"} />
          <Title>
            <Trans>{saleTitle}</Trans>!
          </Title>
          <Hero>- {saleDiscount} %</Hero>
        </Stack>
      </OfferTop>
      <OfferBottom>
        <ExpirationTitle>
          <Trans>Expires in</Trans>
        </ExpirationTitle>
        <Expiration>
          <Countdown seconds={saleExpiration!} />
        </Expiration>
        <SButtonWrap>
          <Button color="primary" variant="outlined" onClick={onClose}>
            <Trans>Continue</Trans>
          </Button>
        </SButtonWrap>
      </OfferBottom>
    </OfferWrap>
  );
};

export default SaleDialogDefault;
